import agent from "../helpers/agent";
export default class Spider {
  static getMarcas() {
    return agent.get("/marcas");
  }

  static getMarcasByVehicleType(vehicleType) {
    return agent.get(`/tipovehiculo/${vehicleType}/marcas`);
  }

  static getModelByVehicleType(vehicleType, id) {
    return agent.get(`/tipovehiculo/${vehicleType}/modelos/${id}`);
  }

  static getBrandByModel(model) {
    return agent.get(`/brandbymodel/?modelId=${model}`);
  }

  static getModelosById(id) {
    return agent.get(`/modelos/${id}`);
  }

  static getHomologation(id, idIntegration) {
    return agent.get(`/homologation/${id}/${idIntegration}`);
  }

  static getHomologatedCars(idCes, idBrand, idModel, idIntegration) {
    return agent.get(`/homologation/${idCes}/${idBrand}/${idModel}/${idIntegration}`);
  }

  static getHomologated(idCes, idBrand, idIntegration) {
    return agent.get(`/homologationbyquery/?id=${idCes}&marca=${idBrand}&idIntegration=${idIntegration}`);
  }

  static getCesByCodSpider(id) {
    return agent.get(`/spider/concesionarie/${id}`);
  }

  static getTasaVFMG(id) {
    return agent.get(`/spider/api/tasaVFMG/v1/${id}`);
  }

  static getGastos() {
    return agent.get(`/spider/api/gastos/v1`);
  }

  static getMonths() {
    return agent.get(`/antiquities`);
  }

  static getPlazos(businessType, vehicleStatus) {
    return agent.get(`/spider/api/plazos/v1/${businessType}/${vehicleStatus}`);
  }

  static getProductos(businessType, vehicleStatus) {
    return agent.get(
      `/spider/api/productos/v1/${businessType}/${vehicleStatus}`
    );
  }

  static getParam(searchCode) {
    return agent.get(`/param/${searchCode}`);
  }

  static calculateFee(data) {
    return agent.post(`/calculateFee`).send(data);
  }

  static inyectionTrinidad(data) {
    return agent.post(`/inyectionTrinidad`).send(data);
  }

  static getRegistration(id) {
    return agent.get(`/register/web/${id}`);
  }
}
